<script setup>
import { getI18n } from '@/plugins/i18n'

const icon = defineModel({ type: String, default: null })

defineProps({
  options: {
    type: Array,
    required: true,
  },
})

const i18n = getI18n()
</script>

<template>
  <q-select v-model="icon" :label="i18n.t('common.icon')" :options="options">
    <template #selected>
      <q-icon :name="icon" size="sm" />
    </template>
    <template #option="scope">
      <q-item v-bind="scope.itemProps" dense>
        <q-item-section avatar><q-icon :name="scope.opt" /></q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
